import { lazyNamed } from 'src/utils/lazyNamed.ts';

export const CreditCardReceipts = {
  Layout: lazyNamed(() => import('./components/Layout.tsx'), 'Layout'),
  Payments: lazyNamed(() => import('./containers/Payments/index.tsx'), 'Payments'),
};
